import * as React from 'react';
import { FC, useLayoutEffect, useState } from 'react';

import { LoyaltyBanner } from 'pages/loyalty/loyalty-banner';
import { isMobile } from 'utils/environment';

import {
  appFooterSelector,
  appHeaderSelector,
  incentiveListSelector,
  mainLayoutSelector,
} from '../loyalty-banner/constants';
import { LoyaltyCtaBar } from '../loyalty-cta-bar';
import LoyaltyFeaturedRewards from '../loyalty-featured-rewards/loyalty-featured-rewards';

import { ContainerWithScroll } from './loyalty-rewards.styled.default';
import { LoyaltyRewardsViewBase } from './loyalty-rewards.view.base';
import { ILoyaltyRewardsViewProps } from './types';

export const LoyaltyRewardsView: FC<ILoyaltyRewardsViewProps> = props => {
  const [containerHeight, setContainerHeight] = useState<number | null>(null);

  const { selectedReward } = props;

  useLayoutEffect(() => {
    const headerDomElement = document.querySelector<HTMLElement>(appHeaderSelector);
    const footerDomElement = document.querySelector<HTMLElement>(appFooterSelector);

    const calculateContainerHeight = () => {
      const sumStaticElementsHeights =
        (headerDomElement?.offsetHeight ?? 0) + (footerDomElement?.offsetHeight ?? 0);

      setContainerHeight(window.innerHeight - sumStaticElementsHeights);
    };

    calculateContainerHeight();

    window.addEventListener('resize', calculateContainerHeight);

    let observer: ResizeObserver;
    if (headerDomElement) {
      observer = new ResizeObserver(calculateContainerHeight);
      observer.observe(headerDomElement as Element);
    }

    const mainLayoutDomElement = document.querySelector<HTMLElement>(mainLayoutSelector);
    if (mainLayoutDomElement) {
      mainLayoutDomElement.style.overflow = 'hidden';
    }

    const incentiveListElement = document.querySelector<HTMLElement>(incentiveListSelector);
    if (incentiveListElement) {
      incentiveListElement.style.overflow = 'auto';
      incentiveListElement.style.maxHeight = 'none';
    }

    return () => {
      window.removeEventListener('resize', calculateContainerHeight);
      if (headerDomElement && observer) {
        observer.unobserve(headerDomElement as Element);
      }

      if (mainLayoutDomElement) {
        mainLayoutDomElement.style.removeProperty('overflow');
      }

      if (incentiveListElement) {
        incentiveListElement.style.removeProperty('overflow');
        incentiveListElement.style.removeProperty('max-height');
      }
    };
  }, []);

  return (
    <ContainerWithScroll height={containerHeight || undefined}>
      <LoyaltyCtaBar />
      {!props.selectedReward && <LoyaltyBanner />}
      {isMobile() && !selectedReward && <LoyaltyFeaturedRewards />}
      <LoyaltyRewardsViewBase {...props} />
    </ContainerWithScroll>
  );
};
